/**** request.js ****/
// 导入axios
import axios from 'axios'
import qs from 'qs'
import proxy from "@/api/proxy.js";
import router from "@/router";
import {getToken,clearAuth} from "../utils/auth";
import { getCachedWxAppletAppCode } from '@/views/cloud/tenant/portalConfig'

const service = axios.create({})

// 创建取消请求
const CancelToken = axios.CancelToken
const source = CancelToken.source()
var cancelList = []
var removePending = () => {
    if (cancelList && cancelList.length) {
        cancelList.map(item => {
            if (item.source) {
                item.source.cancel()
            }
        })
    }
}

/** createWxAppletQr：有配置则注入 appCode，无配置则不传该字段 */
function applyCreateWxAppletQrParams(config) {
    if (!config || !config.url || String(config.url).indexOf('createWxAppletQr') === -1) return
    const appCode = getCachedWxAppletAppCode()
    const applyToObj = (obj) => {
        if (!obj || typeof obj !== 'object' || Array.isArray(obj)) return obj
        if (appCode) obj.appCode = appCode
        else if (Object.prototype.hasOwnProperty.call(obj, 'appCode')) delete obj.appCode
        return obj
    }
    if (config.data == null) {
        if (appCode) config.data = { appCode }
        return
    }
    if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
        if (appCode) config.data.set('appCode', appCode)
        else config.data.delete('appCode')
        return
    }
    if (typeof config.data === 'string') {
        try {
            if (config.data.trim().charAt(0) === '{') {
                const obj = JSON.parse(config.data)
                applyToObj(obj)
                config.data = JSON.stringify(obj)
                return
            }
            const obj = qs.parse(config.data)
            applyToObj(obj)
            config.data = qs.stringify(obj)
        } catch (e) { /* ignore */ }
        return
    }
    if (typeof config.data === 'object') applyToObj(config.data)
}

service.interceptors.request.use(
    (config) => {
        if (process.env.VUE_APP_FLAG != "test") {
            var target = config.url.substring(0, config.url.indexOf("/", 1));
            if (target.indexOf("/") == 0 && target != null && target != "") {
                var domain = proxy[target];
                domain = domain != null ? domain.target : null;
                if (domain != null) config.url = domain + config.url.substring(config.url.indexOf("/", 1));
            }
        }
        // 判断是否是获取验证码接口，是就让他跑，不是就标记为取消
        if (config.url.indexOf('captchaImage') == -1) {
            config.cancelToken = source.token
            cancelList.push(config.cancelToken)
        }

        let token = getToken();

        console.log("------------"+token+"------------");
        
        if (token != null) {
            config.headers.Authorization = token;
        }
        //console.log("------------"+openId+"------------"+token);
        if (config.method == "get") config.data = true;
        applyCreateWxAppletQrParams(config)
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);


service.interceptors.response.use(response => {
    // 拦截响应，统一处理
    try {
        if (response && response.data && response.data.code) {
            let code = response.data.code;

            switch (response.data.code) {
                // 如果是登录过期或者是被人踢下线
                case 600:
                case 601:
                case 602:
                case "600":
                case "601":
                case "602":
                    window.sessionStorage.removeItem("custGlobalId");
                    window.sessionStorage.removeItem("accessToken");
                    window.sessionStorage.removeItem("openId");
                    window.sessionStorage.removeItem("userInfo");
                    window.sessionStorage.removeItem("systemList");
                    window.sessionStorage.removeItem("userDetail");
                    clearAuth();
                    let url = window.location.href;
                    let link = url.substring(url.lastIndexOf("/"));
                    var loginInfo = {loginInfo: {login: false, right: false, msg: "登录过期，请重新登录！"}, link: link};
                    // 先中断除了获取验证码的请求
                    removePending();
                    let href = window.location.protocol + "//" + window.location.host;
                    console.log(href)
                    try {
                        if (window.vue && window.vue.portalCheckRight) {
                            window.vue.portalCheckRight({
                                login: false,
                                right: false,
                                msg: "登录过期，请重新登录！"
                            }, link);
                        } else {
                            top.location = href
                            // window.location.href = href
                            return false;
                        }
                    } catch (e) {
                        top.location = href
                        // window.location.href = href
                        return false;
                    }
                    return response
            }
            return response
        } else {
            return response
        }
    } catch (err) {
        return Promise.reject(err)
    }

})

export default service